export const dataFetchTreeNormalTree = {
  "tree": {
    "unions": [
      {
        "u": 5156,
        "t": "c",
        "m": "932284",
        "p": [
          5157,
          5158
        ],
        "c": [
          5155
        ]
      }
    ],
    "nodes": [
      {
        "n": 5155,
        "pid": "40003822",
        "pr_id": "52295",
        "d_t": 1,
        "x": 0,
        "y": 0,
        "npu": "2",
        "d_r": 1,
        "l": 1,
        "g": "f",
        "dob_y": "2009",
        "nn": "3821",
        "app": 1,
        "tm": "0",
        "fn": "Sierra",
        "mn": "Hope",
        "ln": "Stangel",
        "nm": "Sierra Hope STANGEL",
        "tag": 1,
        "del": 1,
        "a": 1,
        "e": 1,
        "g_e": "1",
        "focus": 1
      },
      {
        "n": 5157,
        "pid": "40131124",
        "pr_id": "932281",
        "x": -3,
        "y": 4,
        "d_r": 1,
        "lf": 1,
        "p_o": "5158",
        "l": 1,
        "g": "m",
        "nn": "131195",
        "app": 1,
        "tm": "0",
        "fn": "Other Father",
        "ln": "Stangel",
        "nm": "Other Father STANGEL",
        "tag": 1,
        "del": 1,
        "a": 1,
        "e": 1,
        "g_e": "1"
      },
      {
        "n": 5158,
        "nt": "ghost",
        "x": 3,
        "y": 4,
        "d_r": 1,
        "p_o": "5157",
        "fn": "This Person",
        "nm": "This Person",
        "a": 1,
        "g": "f"
      }
    ],
    "metadata": {
      "request": "fetch_tree",
      "fetch_floaters": "1",
      "preferences": {
        "show_help": "0",
        "show_guide": "0",
        "guide_page": "3",
        "display_type": "0",
        "prune_ancestors_num": "3",
        "show_arrows": "1",
        "show_photos": "1",
        "show_email": "1",
        "maiden_display": "3",
        "show_middle_names": "1",
        "show_suffixes": "1",
        "ignore_display_name": "0",
        "mark_deceased": "0",
        "lifelines": "0",
        "neutral_backgrounds": "0",
        "show_ancestors": "0",
        "show_descendants": "0",
        "min_font": "9",
        "max_font": "12",
        "render_quality": "0",
        "auto_show_tray": "0",
        "flip_nodes": "0",
        "show_floaters_help": "0",
        "show_cycles_help": "0",
        "single_parents": "0",
        "click_to_flip": "0",
        "extended_node_entry": "0",
        "prune_descendants_num": "2",
        "new_profile_window": "0",
        "hide_profile_matches": "0",
        "tree_version": "canvas",
        "new_user": "0",
        "show_undeletable": "1",
        "chart_type": "default",
        "add_node_type": "0",
        "hide_tree_posters_help": "1",
        "reverse_rtl": "0",
        "no_email_reminder": "0",
        "hide_public_warning": "0",
        "date_format": "0",
        "change_notify_time": "14",
        "hide_invitable": "0",
        "revisions_mode": "1",
        "revisions_time": "14",
        "date_entry": "0",
        "skip_prepopulating_names": "0",
        "hide_hot_match_prompt": "1",
        "invitable_hidden_at": "October 19, 2018 at 9:03 AM",
        "hide_record_match_prompt": "1",
        "hide_invite_prompt": "0",
        "hide_no_flash_redirect_dialog": "0",
        "enable_union_highlighting": "0",
        "show_surname_caps": "1",
        "hide_don_king_help": "0",
        "styles": "{\"1\":{\"selectedtheme\":\"default\",\"fontSizeChoice\":\"default\",\"custom\":{\"maleCustomPresetColor\":\"#A9CFE7\",\"femaleCustomPresetColor\":\"#F6B8DB\",\"unGenderedCustomPresetColor\":\"#C8F176\",\"stageBackgroundCustomPresetColor\":\"#EEF0DD\"}}}",
        "time_format": "0"
      },
      "infos": {
        "max_ancestor_gen": "1",
        "max_descendant_gen": "0"
      }
    }
  }
}
